class BESSAppProjectProfilerFieldData {

    constructor(data) {
        this.fieldNo = data['field_no'];
        this.label = data['display_label'];
        this.variable = data['variable'];
        this.inputType = data['input_type'];
        this.defaultValue = data['default_value'];
        this.placeholder = data['placeholder'];
        this.questionIdentifier = data['question_identifier'];
        this.isReadOnly = data['readonly'];
        this.tooltip = data['tooltip'];
        this.tooltipImage = data['tooltip_image'];
        this.units = data['units'];
        this.isRequired = data['required'];
        this.introText = data['intro_text'];
        this.choices = data['choices'] === null ?
            null : _.map(data['choices'], (x) => new BESSAppProjectProfilerFieldChoiceData(x));
        this.autoSelect = data['autoSelect'];
        this.meta = data['meta'];
        this.attributes = data['attributes'];
        this.questionIdentifier = null;
        if ('data-this-question-identifier' in this.attributes) {
            this.questionIdentifier = this.attributes['data-this-question-identifier'];
        }
        this.validationError = data['validation_error'];

        this.choicesMap = {};
        _.each(this.choices, function (x) {
            this.choicesMap[x.key] = x
        }.bind(this));

        if (this.inputType === BESSAppInputType.choice &&
            (this.choices === null || (this.autoSelect && this.choices.length <= 1)) &&
            this.variable !== 'state') {
            this.isReadOnly = true;
        }

        if (this.inputType === BESSAppInputType.hidden) {
            this.isHidden = true;
        }

        this.dependencies = _.map(data['dependencies'], (x) => new BESSAppProjectProfilerDependencyData(x));
        let questionData = data['question'];
        if ('dependency' in questionData) {
            this.dependencies.push(new BESSAppProjectProfilerDependencyData(questionData['dependency']));
        }

        this.extra = data['extra'];
    }

    getTooltipContent() {
        let content = this.tooltip;
        if (this.tooltipImage != null) {
            content += '<img src="' + this.tooltipImage + '">';
            console.log(content);
        }
        return content;
    }

    getEventIdentifier() {
        let identifier = this.questionIdentifier;
        if (identifier == null) {
            identifier = this.variable;
        }
        return identifier;
    }

    findChoiceMatching(value) {
        if (this.variable === 'building') {
            let index = parseInt(value);
            if (!isNaN(index)) {
                return this.choices[index];
            }
        }
        let match = _.find(this.choices, (x) => x.key === value);
        if (match === undefined) {
            match = _.find(this.choices, (x) => x.value === value);
        }
        if (match === undefined) match = null;
        return match;
    }

}
